// Tile — the stand's small tilted 3D tile (operator 2026-10-08, ref 19): a
// gradient face over a darker 2px side, rotated a few degrees. It carries a
// glyph (Phosphor fill) as part of the illustration. Used where the Soft style
// allows its one playful accent: the Discover categories.

import type { ReactNode } from 'react'
import styles from './Tile.module.css'

export type TileTone = 'gold' | 'flame' | 'violet' | 'mint' | 'blue' | 'graphite'

export function Tile({
  tone,
  large = false,
  className,
  children,
}: {
  tone: TileTone
  large?: boolean
  className?: string
  children: ReactNode
}) {
  return (
    <span
      className={`${styles.tile}${large ? ` ${styles.large}` : ''}${className ? ` ${className}` : ''}`}
      data-tone={tone}
      aria-hidden="true"
    >
      <span className={styles.face}>{children}</span>
    </span>
  )
}
